export const formatLabel = (important:boolean | undefined, label: string) => {
    return important ? `${label}*`  : label;
}